import { count } from 'rxjs/operators';

export abstract class BaseService {
  log(...parameters: any[]) {
    const traceList = [this];
    traceList.push(...parameters);
    console.log(traceList);
  }
  fUrl(url:string, moduleName?: string){
    if(url.indexOf("api/")===0) {
      return url;
    }
    //hash: "#/dynamic/singleWindow/vmsOilCard"
    if(!moduleName){
      const hash=window.location.hash;
      const endIndex=hash.indexOf('/dynamic/');
      console.log(hash);
      console.log(endIndex);
      moduleName=hash.substring(2,endIndex)
    }
    return `api/${moduleName}/${url}`;
  }
}
